import { Operator } from './operator';

export class GreaterThan implements Operator {
	public evaluate(value: number, target: number): boolean {
		return value > target;
	}
}
